import React from 'react';

import clsx from 'clsx';

import styles from './ButtonOption.module.scss';

interface ButtonOptionProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
}

const ButtonOption = ({ active = false, className, ...buttonProps }: ButtonOptionProps) => {
  return (
    <button
      type="button"
      className={clsx(styles.button, className, {
        [styles.buttonActive]: active,
        [styles.buttonInactive]: !active,
      })}
      {...buttonProps}
    />
  );
};

export default ButtonOption;
